module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("W")]), _vm._v("riting any history book – unless it is researched exclusively by an author in his own lifetime – invariably depends on the work of others. This book is no exception. I owe a debt of gratitude to the many writers and scholars past and present who have inspired, entertained and informed me while I researched and wrote this book. That said, errors and omissions are of course my own.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In writing this book I want to thank Simon Fowler, not only for his confidence in me to suggest the original idea, but also for his help along the way and with the illustrations. I would also like to thank Rupert Harding at Pen & Sword Books for his patience when at times other unrelated matters took precedence over writing. I am also grateful to Ray Whitehand of Historical Suffolk Research Service for his advice on the early Poor Laws and transcripts of documents. Last, but not least, a thank you must go to my wife, Lyn, for her encouragement and support. In particular for her secretarial skills and reading through what must have seemed like countless drafts and in keeping me supplied with endless cups of tea.")])])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44f28cf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783830763_ack01.vue
// module id = 75
// module chunks = 0